import { render, staticRenderFns } from "./CardRowData.vue?vue&type=template&id=59639f2a&"
import script from "./CardRowData.vue?vue&type=script&lang=ts&"
export * from "./CardRowData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports